/* eslint-disable react/no-array-index-key */
import type { LinkedItemPriceInfoViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { LinkedItemText, LinkedItemTextBottleDeposit } from 'autogen/translation-keys/trans-website-basket';
import { format } from 'modules/helpers/strings';

export default function LinkedItemPrices({ model: linkedItems }: { model: LinkedItemPriceInfoViewModel[] }) {
    const { t } = useTranslation();

    if (!linkedItems.length) return null;

    return (
        <Flex.Column gap="0">
            {linkedItems.map((linkedItem, index) => {
                if (linkedItem.type === 'BottleDeposit') {
                    return (
                        <Typography.Body as="span" size="S" key={index}>
                            {format(t(LinkedItemTextBottleDeposit))(linkedItem.subTotal)}
                        </Typography.Body>
                    );
                }
                return (
                    <Typography.Body as="span" size="S" key={index}>
                        {format(t(LinkedItemText))(linkedItem.description, linkedItem.subTotal)}
                    </Typography.Body>
                );
            })}
        </Flex.Column>
    );
}
